import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) =>
  createStyles({
    list: {
      marginBottom: theme.spacing(1),
    },
  })
);
